module.exports = __webpack_public_path__ + "static/media/cc-physical-therapy.414e670e.png";